import type { VerifyLoadingStepVisual } from '../../hooks/useVerifyLoadingProgress'

type Props = {
  label: string
  visual: VerifyLoadingStepVisual
}

function StepIcon({ visual }: { visual: VerifyLoadingStepVisual }) {
  if (visual === 'done') {
    return (
      <span className="verify-loading-step__icon verify-loading-step__icon--done">
        <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M20 6 9 17l-5-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    )
  }
  if (visual === 'error') {
    return (
      <span className="verify-loading-step__icon verify-loading-step__icon--error">
        <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 8v5M12 16h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        </svg>
      </span>
    )
  }
  if (visual === 'active') {
    return <span className="verify-loading-step__icon verify-loading-step__icon--active" aria-current="step" />
  }
  return <span className="verify-loading-step__icon verify-loading-step__icon--pending" />
}

export default function VerifyProgressStep({ label, visual }: Props) {
  return (
    <li className={`verify-loading-step verify-loading-step--${visual}`}>
      <div className="verify-loading-step__node">
        <StepIcon visual={visual} />
        <span className="verify-loading-step__label">{label}</span>
      </div>
    </li>
  )
}
